module.exports = __webpack_public_path__ + "static/media/piernas.972d2526.svg";